var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureLightning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 0a25 25 0 1 0 0 50 25 25 0 0 0 0-50zm1.667 34.6v1.883a1.666 1.666 0 1 1-3.334 0v-1.866a5.835 5.835 0 0 1-3.716-3.334 1.666 1.666 0 0 1 1.55-2.233 1.667 1.667 0 0 1 1.566.983A2.417 2.417 0 0 0 25 31.567a2.451 2.451 0 0 0 2.467-2.45A2.5 2.5 0 0 0 25 26.55a5.9 5.9 0 0 1-5.25-8.433 5.45 5.45 0 0 1 3.583-3V13.2a1.666 1.666 0 1 1 3.334 0v1.967a5.8 5.8 0 0 1 2.416 1.4A5.983 5.983 0 0 1 30.4 18.55a1.666 1.666 0 0 1-1.533 2.133 1.666 1.666 0 0 1-1.584-.95 2.85 2.85 0 0 0-.55-.8 2.5 2.5 0 0 0-1.666-.716 2.483 2.483 0 0 0-2.45 2.466 2.55 2.55 0 0 0 2.366 2.534 6.083 6.083 0 0 1 5.85 5 5.833 5.833 0 0 1-4.166 6.383z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureLightning);
export default __webpack_public_path__ + "static/media/feature-lightning.6014c5dbac668ebd07dc358942c60437.svg";
export { ForwardRef as ReactComponent };